import { gql } from '@apollo/client/core'

export const addToCartMutation = gql`
mutation addProductToCart($input: CreateCartItemInput!){
  createCartItem(input : $input){
    errors
    success
  }
}
`

export const getEstimateQuery = gql`
  query estimateDetail(
    $printableSkuId: ID!,
    $sizes: String!,
    $addonPrintableSkuId: ID,
    $originalOrderItemId: ID
  ){
    estimate(
      printableSkuId: $printableSkuId,
      sizes: $sizes
      addonPrintableSkuId: $addonPrintableSkuId,
      originalOrderItemId: $originalOrderItemId,
    ) {
      id
      amount
      quantity
      quantityUnit
      printableSku {
        skuColorPattern {
          colorPattern {
            displayName
          }
        }
        skuEditPattern {
          editPattern {
            displayName
          }
        }
        sku {
          product {
            displayName
          }
        }
      }
    }
  }
`

export const brandsQuery = gql`
  query brands {
    brands {
      brandName
      displayName
      id
      logoImage
    }
  }
`

export const industriesQuery = gql`
  query industriesList {
    industries {
      id
      topPageImage
      industryName
      displayName
    }
  }
`

export const cmsCategoryProductsQuery = gql`
  query cmsCategoryResolver(
    $id: ID!
    $offset: Int!
    $limit: Int!
  ) {
    cmsCategory(id: $id, offset: $offset, limit: $limit) {
      id
      totalProductCount
      products {
        id
        brand
        url
        displayName
        description
        gender
        quantityUnit
        minProductPrice
        skuDetailsNonSearchPage {
          skuImage
          psi
        }
        productCardItems {
          productCardDisplayName
          color
        }
        hasFastShipping
      }
    }
  }
`
export const userDesignsQuery = gql`
  query designImagesModal {
    userDesigns {
      uuid
      imageUrl
      nonTransparentVersion {
        uuid
      }
      fileExtension
      supportedTransparency
      isDefault
    }
  }
`

export const deleteDesignMutation = gql`
  mutation deleteUserDesign ($input: DeleteInput!) {
    deleteUserDesign(input: $input) {
      success
      errors
    }
  }
`

export const getCMSLinksQuery = gql`
  query cmsMappingResolver($mappableType: CmsMappingTypeEnum!, $mappableIds: [ID!]!) {
    cmsMapping(mappableType: $mappableType, mappableIds: $mappableIds) {
      cmsCategories {
        h1
        url
      }
      cmsMagazines {
        h1
        url
        mainImage
      }
    }
  }
`

export const remainingFastShippingQuantityQuery = gql`
  query remainingFastShippingQuantity($psi: ID!) {
    fastShippingLimit(psi: $psi) {
      remainingQuantity
    }
  }
`
